import { createReducer, makeActionCreator } from "util/redux";

export const types = {
    DOWNLOAD_FILE_REQUEST: "files/DOWNLOAD_FILE_REQUEST",
    DOWNLOAD_FILE_SUCCESS: "files/DOWNLOAD_FILE_SUCCESS",
    GET_FILE_CONTENTS_REQUEST: "files/GET_FILE_CONTENTS_REQUEST",
    GET_FILE_CONTENTS_SUCCESS: "files/GET_FILE_CONTENTS_SUCCESS",
    LOAD_ECHEQ_FILE_REQUEST: "files/LOAD_ECHEQ_FILE_REQUEST",
    LOAD_ECHEQ_FILE_SUCCESS: "files/LOAD_ECHEQ_FILE_SUCCESS",
};

export const INITIAL_STATE = {
    fetching: false,
    fetchingFile: false,
    responseData: undefined,
    lines: [],
};

export default createReducer(INITIAL_STATE, {
    [types.DOWNLOAD_FILE_REQUEST]: () => ({ ...INITIAL_STATE, fetching: true }),
    [types.DOWNLOAD_FILE_SUCCESS]: (state) => ({
        ...state,
        fetching: false,
    }),
    [types.LOAD_ECHEQ_FILE_REQUEST]: (state) => ({ ...state, fetchingFile: true }),
    [types.LOAD_ECHEQ_FILE_SUCCESS]: (state, { responseData }) => ({
        ...state,
        responseData,
        fetchingFile: false,
    }),
});

export const actions = {
    getFileContentsRequest: makeActionCreator(types.GET_FILE_CONTENTS_REQUEST, "idFile", "deleteFile", "idUserCreator"),
    downloadFileRequest: makeActionCreator(types.DOWNLOAD_FILE_REQUEST, "idFile", "fileName"),
    downloadFileSuccess: makeActionCreator(types.DOWNLOAD_FILE_SUCCESS),
    loadEcheqFileRequest: makeActionCreator(
        types.LOAD_ECHEQ_FILE_REQUEST,
        "formData",
        "load",
        "onFileProcess",
        "onError",
        "error",
    ),
};

// Selectors
export const selectors = {
    isFetching: (state) => state.files.fetching,
    getResponseData: (state) => state.files.responseData,
};
